import { FC, useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useFetch from "../../../../hooks/useFetch";
import { IssuesApiResponse } from "../../../../type/entities/issues-type";
import FormGroup from "../../../../layout/shared/form-group";
import { Input, Switch, Textarea } from "rizzui";
import { cloudCover, sex, age, windDirectionsSpanish, windSpeed } from "../../../../utils/SelectorMapping";
import { usePrivilege } from "../../../../components/priviledge/PriviledgeProvider";
import CarrionProfileLayout from "../CarrionProfileLayout";
import { CarrionService } from "../../../../services/carrion/carrionService";

interface CarrionInfoProps {
    
}


const CarrionInfo: FC<CarrionInfoProps> = () => {
    
    // STATES 

    const [huso, setHuso] = useState<string>('');
    const [coordinatesX, setCoordinatesX] = useState<string>('');
    const [coordinatesY, setCoordinatesY] = useState<string>('');
    const [isProtected, setIsProtected] = useState<boolean>(false);
    const [isRefecth, setIsRefecth] = useState<boolean>(true);

    // HOOKS

    const {id  = ''} = useParams<{ id: string }>();
    const service = new CarrionService();
    const { userCan } = usePrivilege();


    // DATA FETCHING

    const [data, loading] = useFetch(useCallback(async () => {
        if (!id || id === '' || isRefecth == false) return null;
        if (isRefecth) setIsRefecth(false);
        const response = await service.getCarrionById(id);
        return response.getResponseData() as IssuesApiResponse;
    }, [id, isRefecth]));

    // USE FETCH
    
    useEffect(() => {
        if (data) {
            const coordinates = data?.coordinates.split(',');
            setHuso(coordinates[0]);
            setCoordinatesX(coordinates[1]);
            setCoordinatesY(coordinates[2]);

            if(data?.species?.catAndalucia || data?.species?.catNacional){ 
                setIsProtected(true);
            }else {
                setIsProtected(false);
            }
            
        }
    }, [data]);
    
    // RENDER 

    return (
        <>
            <div className="@container">
                <FormGroup
                    title="Datos de la Incidencia"
                    description='Información de la incidencia'
                    className='pt-3 pb-4'
                    titleCols="@md:col-span-12"
                    childCols="@md:col-span-12 "
                >
                    {userCan('list','companies') && (
                        <div className="grid md:grid-cols-1 grid-cols-1 gap-2" >
                            <Input
                                disabled
                                label="Compañia"
                                placeholder="Compañia"
                                value={data?.company?.name ?? ''}
                            />
                        </div>
                    )}
                    <div className={`grid md:grid-cols-2 grid-cols-1 gap-2`} >
                        <Input
                            disabled
                            label="Id"
                            placeholder="Id"
                            value={data?.id ?? ''}
                        />
                        <Input
                            disabled
                            label="Código"
                            placeholder="Código"
                            value={data?.carrionId ?? ''}
                        />
                    </div>

                    <div className="grid md:grid-cols-4 grid-cols-1 gap-2" >
                        <Input
                            disabled
                            label="Parque eólico"
                            placeholder="Parque"
                            value={data?.park?.name ?? ''}
                        />
                        <Input
                            disabled
                            label="Aerogenerador"
                            placeholder="Alias"
                            value={data?.windTurbine?.alias ?? ''}
                        />
                        <Input
                            disabled
                            label="Especie afectada"
                            placeholder="Especie"
                            value={data?.species?.scientificName ?? ''}
                            inputClassName="italic"
                        />
                        <Input
                            disabled
                            label="Observador"
                            placeholder="Observador"
                            value={(data?.user?.name ?? '') + ' ' + (data?.user?.lastName ?? '')}
                        />
                    </div>

                    <div className="grid md:grid-cols-3 grid-cols-1 gap-2" >
                        <Input
                            disabled
                            label="Dirección del viento"
                            placeholder="Dirección del viento"
                            value={
                                data?.windDirection
                                ? windDirectionsSpanish.find(option => option.value == data?.windDirection)?.label ?? 'Sin datos'
                                : 'Sin datos'
                            }
                        />
                       <Input
                            disabled
                            label="Intensidad del viento"
                            placeholder="Intensidad del viento"
                            value={
                                data?.windSpeed == 0 || data?.windSpeed !== null
                                ? windSpeed.find(option => option.value == String(data?.windSpeed))?.label ?? 'Sin datos'
                                : 'Sin datos'
                            }
                        />
                        <Input
                            disabled
                            label="Cobertura de nubes"
                            placeholder="Cobertura de nubes"
                            value={
                                data?.cloudCoverage == 0 || data?.cloudCoverage !== null
                                ? cloudCover.find(option => option.value == String(data?.cloudCoverage))?.label ?? 'Sin datos'
                                : 'Sin datos'
                            }
                        />
                    </div>
                    <div className="grid md:grid-cols-3 grid-cols-1 gap-2" >
                        <Input
                            disabled
                            label="Huso"
                            placeholder="Huso"
                            value={huso}
                        />
                        <Input
                            disabled
                            label="Coordenadas X"
                            placeholder="Coordenadas X"
                            value={coordinatesX}
                        />
                        <Input
                            disabled
                            label="Coordenadas Y"
                            placeholder="Coordenadas Y"
                            value={coordinatesY}
                        />
                    </div>

                    <div className="grid md:grid-cols-3 grid-cols-1 gap-2" >
                        <Input
                            disabled
                            label="Fecha del Reporte"
                            placeholder="Reportado el"
                            value={data?.dateReported ? new Date(data?.dateReported?.date).toLocaleDateString('es-ES', {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                            }) : 'Sin fecha'}
                        />
                        <Input
                            disabled
                            label="Fecha de creación"
                            placeholder="Fecha de creación"
                            value={data?.createdAt ? new Date(data?.createdAt?.date).toLocaleDateString('es-ES', {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                            }) : 'Sin fecha'}
                        />
                        <Input
                            disabled
                            label="Fecha de ultima modificación"
                            placeholder="Ultima modificación"
                            value={data?.updatedAt ? new Date(data?.updatedAt?.date).toLocaleDateString('es-ES', {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                            }) : 'Sin fecha'}
                        />
                    </div>

                    <div className="grid md:grid-cols-3 grid-cols-1 gap-2" >

                        <Input
                            disabled
                            label="Edad del Ejemplar"
                            placeholder="Edad del Ejemplar"
                            value={
                                data?.age !== 0 && data?.age !== null
                                ? age.find(option => option.value == data?.age)?.label ?? 'Sin datos'
                                : 'Sin datos'
                            }
                        />

                        <Input
                            disabled
                            label="Sexo del Ejemplar"
                            placeholder="Sexo del Ejemplar"
                            value={data?.sex 
                                ? sex.find(option => option.value == data?.sex)?.label ?? 'Sin datos'
                                : 'Sin datos'
                            }
                        />

                        <Input
                            disabled
                            label="Distancia al Aerogenerador"
                            placeholder="Distancia al Aerogenerador"
                            value={
                                data?.distanceFromTurbine !== 0 || data?.distanceFromTurbine !== null
                                ? String(data?.distanceFromTurbine) + ' m'
                                : 'Sin datos'
                            }
                        />

                    </div>

                    <div className="grid md:grid-cols-2 grid-cols-1 gap-2" >

                        <Switch
                            id="turbineOff"
                            label="Parada de Aerogenerador"
                            checked={data?.turbineOff ?? false}
                            className="flex-grow"
                        />
                        <Switch
                            id="avianPresencia"
                            label="Presencia de aves"
                            checked={data?.avianPresencia ?? false}
                            className="flex-grow"
                        />
                        <Switch
                            id="notifiedEnvAgency"
                            label="Notificado a AMA"
                            checked={data?.notifiedEnvAgency ?? false}
                            className="flex-grow"
                        />
                        <Switch
                            id="notifiedOwner"
                            label="Notificado al propietario"
                            checked={data?.notifiedOwner ?? false}
                            className="flex-grow"
                        />

                        {data?.notifiedOwner === true ? (
                            <Input
                                disabled
                                label="Nombre del propietario"
                                placeholder="Nombre del propietario"
                                value={data?.nameOwner}
                            />
                        ) : null}

                    </div>

                    <div className="grid grid-cols-1 gap-2" >
                        <Textarea
                            id='comments'
                            disabled
                            label='Observaciones'
                            rows={6}
                            value={data?.comments}
                            onChange={(e) => data?.setFieldValue('comments', e.target.value)}
                            className="mb-4"
                        />
                    </div>

                </FormGroup>
            </div>
        </>
    )
}

export default CarrionInfo;